import { render, staticRenderFns } from "./ProfilePopUp.vue?vue&type=template&id=68951e4d&scoped=true"
import script from "./ProfilePopUp.vue?vue&type=script&lang=js"
export * from "./ProfilePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68951e4d",
  null
  
)

export default component.exports